module.exports = __webpack_public_path__ + "img/attente.e4ce621b.png";